import { onDomContentLoaded } from "Functions/helpers";

import(/* webpackChunkName: "default-layout" */ "Layouts/default");

onDomContentLoaded(() => {
    document.querySelector('.js-branches-tabs').addEventListener('rTab.after.openTab', (event) => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("tab-id", event.detail.activeTabs[0]);
        const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
        window.history.replaceState({path: newUrl}, '', newUrl);
    });
});